import React, {Fragment} from 'react';
import TextInput from './../TextInput';
import Select from './../Select';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../../utils/dotutils';
import PropTypes from 'prop-types';
import RadioGroup from "../RadioGroup";
import connect from "react-redux/es/connect/connect";

class PaymentControl extends React.Component {

    static propTypes = {
        required: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        value: PropTypes.any,
        fields: PropTypes.array,
        layout: PropTypes.any,
        providerTheme: PropTypes.oneOf(["select","radio"]),
    }

    setFieldValue = (field, value) => {
        let oldValue = get(this.props.value, field);
        if (!isEqual(oldValue, value)) {
            const v = Object.assign({}, this.props.value);
            set(v, field, value);
            this.setState({
                ...this.state
            });
            this.props.saveChanges((this.props.name || 'payment'), v);
        }
    }

    providerTheme = () => {
        const theme = this.props.providerTheme || "select";
        if (theme === "select") {
            return <Select
                required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("serviceprovider_type") !== -1)}
                name={"serviceprovider_type"}
                component="PaymentServiceProvider"
                storeType="local"
                labelKey="methodname"
                valueKey="id"
                objectValue={false}
                options={this.props.availableProviders}
                value={this.props.value && this.props.value.serviceprovider_type}
                saveChanges={(name, value) => {
                    this.setFieldValue("serviceprovider_type", value)
                }}
                disabled={this.props.disabled === true || (Array.isArray(this.props.disabled) && this.props.disabled.indexOf("serviceprovider_type") !== -1)}
                label="Fizetés módja"
            />;
        } else if(theme === "radio") {
            return <RadioGroup
                required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("serviceprovider_type") !== -1)}
                name={"serviceprovider_type"}
                component="PaymentServiceProvider"
                labelKey="methodname"
                valueKey="id"
                objectValue={false}
                options={this.props.availableProviders}
                value={this.props.value && this.props.value.serviceprovider_type}
                saveChanges={(name, value) => {
                    this.setFieldValue("serviceprovider_type", value)
                }}
                disabled={this.props.disabled === true || (Array.isArray(this.props.disabled) && this.props.disabled.indexOf("serviceprovider_type") !== -1)}
                label="Fizetés módja"
            />;
        }
    }

    getLayout = (fields, name) => {
        if (name !== '') {
            name += '.';
        }
        let other = null;
        let colClass = "col-md-12";
        if (this.props.value && this.props.value.serviceprovider_type === "Cod") {
            other = <div className="col-sm-6">
                <TextInput
                    required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("amount") !== -1)}
                    type="number"
                    name={name + "amount"}
                    value={this.props.value.amount}
                    label="Utánvét díja"
                    saveChanges={(name, value) => {this.setFieldValue("amount", value)}}
                />
            </div>;
            colClass = "col-md-6";
        } else if (this.props.value && this.props.value.serviceprovider_type === "Cash") {
            other = <div className="col-sm-6">
                <Select
                    required={this.props.required === true}
                    component="MoneyRepository"
                    value={this.props.value.moneyrepository}
                    filter={[{field: "component_type", value: "CashRepository"},{field: "partner", value: this.props.pos.partner.partner_id}]}
                    objectValue={false}
                    labelKey="name"
                    storeType="local"
                    label="Pénztár"
                    isClearable={true}
                    saveChanges={(name, value) => {this.setFieldValue("moneyrepository", value)}}
                />
            </div>;
            colClass = "col-md-6";

        }
        const method = <div className={colClass}>
            {this.providerTheme()}
        </div>;
        return <Fragment>
            {method}
            {other}
        </Fragment>;
    }

    render() {
        const fields = this.props.fields || ['method', 'amount'];
        let name = this.props.name || 'payment';
        return this.props.layout ? this.props.layout(fields, name) : this.getLayout(fields, name);
    }

}

export default connect((state) => {
    return {
        pos: (state.app.till || {}).pos || {},
    };
}, {})(PaymentControl);